import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserRoleEnum } from '../types/apiGeneratedTypes';

export interface AdminUser {
  role: UserRoleEnum | '';
  user_id: string;
  is_super_admin: boolean;
  email: string;
  first_name?: string;
  last_name?: string;
}

export const initialState: { admin: AdminUser } = {
  admin: {
    role: '',
    user_id: '',
    is_super_admin: false,
    email: '',
    first_name: '',
    last_name: '',
  },
};

const adminSlice = createSlice({
  name: 'adminUser',
  initialState,
  reducers: {
    setAdminUserInfo(state, action: PayloadAction<AdminUser>) {
      state.admin = action.payload;
    },
  },
});

export const { setAdminUserInfo } = adminSlice.actions;
export default adminSlice.reducer;
